import React, { useEffect } from 'react';
import { StyledHeroProductsStatic } from './StyledHeroProductsStatic';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

// commento
const HeroProductsStatic = ({ title, img, subtitle, bgPosition }) => {
   
  useEffect(() =>{
    gsap.to('.parallax',{
      y: '-50%',
      ease: "none",
      scrollTrigger:{
        trigger: ".background--cover-img",
        start: "top 100",
        scrub: 0.5
      }
    })
  }, [])
  return (
    <React.Fragment>
      {
          <StyledHeroProductsStatic bgPosition={bgPosition}>
            <div className="content--wrap content--white" >
              <h4 className="big--title content--black parallax" dangerouslySetInnerHTML={{ __html: title }}></h4> 
              <div className="background--cover-img" style={{backgroundImage: `url(${img})` }}></div>
              <div className="mask--title">
                <h4 className="big--title content--white parallax" dangerouslySetInnerHTML={{ __html: title }}></h4> 
              </div>
            </div>
          </StyledHeroProductsStatic>
          
      }
      <p className="preset-10 under--hero">{subtitle}</p>

    </React.Fragment>
  );
};

HeroProductsStatic.propTypes = {};

HeroProductsStatic.defaultProps = {
  tag: "div"
};

export default HeroProductsStatic;
